import React from 'react'

export class ComponentWithModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {isModalActive: false}
  }

  showModal = (event) => {
    if (event) event.preventDefault()
    this.setState({isModalActive: true})
  }

  hideModal = (event) => {
    if (event) event.preventDefault()
    this.setState({isModalActive: false})
  }

  modalBackground() {
    if (!this.state.isModalActive) return null
    return <div className='modal'
                style={ {display: 'block', background: 'black', opacity: 0.1} }
                onClick={ this.hideModal }></div>
  }
}
